import BaseVue from '@/base/BaseVue';
// @ts-ignore
import {Prop} from 'vue-property-decorator';
export default class MiTitle extends BaseVue {
  @Prop() text!: string;
  @Prop() tip!: string;
}
